module.exports = __webpack_public_path__ + "img/satelite.699a3493.svg";